module.exports = "./img/8ae56f2c462f27dd11e55ddb1b5d3c37.jpg";